<template>
  <div>
    <div class="mb-3" style="font-size: 13px">
      Acompanhe o status das suas inscrições como juiz abaixo:
    </div>

    <div
      v-if="enrollments && enrollments.length"
      class="row flex-wrap"
      style="justify-content: space-between"
    >
      <JudgeCard
        v-for="enrollment in enrollments"
        :key="enrollment._id"
        class="mb-3"
        style="flex-basis: 49%"
        :enrollment="enrollment"
      />
    </div>
  </div>
</template>

<script>
import JudgeCard from "@/components/Judge/Card";

export default {
  name: "JudgeEnrollments",

  components: {
    JudgeCard,
  },
  props: {
    enrollments: {
      type: Array,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Judge/Enrollments/index.vue